export const LOGINSUCCESS ="LOGINSUCCESS";
export const LOGINREQUEST ="LOGINREQUEST";
export const LOGINREJECTED ="LOGINREJECTED";

export const REGISTERSUCCESS ="REGISTERSUCCESS";
export const REGISTERREQUEST ="REGISTERREQUEST";
export const REGISTERREJECTED ="REGISTERREJECTED";

export const LOGOUT="LOGOUT";
